import { fetch, fetchPreview } from "../index";
import { page, pageMetaData, pageSupplementaryData } from "../queries/page";

import { GRAPHQL_URL } from "../constants";

/**
 * Fetch Page data from GraphQL
 *
 * @param {string} path the data to grab for the page
 * @return {Promise<void>} the result of the query
 */
export async function fetchPage(path, isPreview, lineupSwap) {
    if (!path) {
        return;
    }

    if (isPreview) {
        return await fetchPreview(GRAPHQL_URL, {
            query: page(path, isPreview),
        });
    }

    if (lineupSwap) {
        return await fetch(GRAPHQL_URL, {
            query: page(path, isPreview),
            variables: {
                lineupSwap,
            },
        });
    }

    return await fetch(GRAPHQL_URL, {
        query: page(path, isPreview),
    });
}

/**
 * Fetch Page supplementary data from GraphQL
 *
 * @param {string} path the data to grab for the page
 * @return {Promise<void>} the result of the query
 */
export async function fetchPageSupplementaryData(path, isDetail) {
    if (!path) {
        return;
    }

    return await fetch(GRAPHQL_URL, {
        query: pageSupplementaryData(path, isDetail),
    });
}

/**
 * Fetch Page metadata from GraphQL
 *
 * @param {string} path the data to grab for the page
 * @return {Promise<void>} the result of the query
 */
export async function fetchPageMetaData(path) {
    if (!path) {
        return;
    }

    return await fetch(GRAPHQL_URL, {
        query: pageMetaData(path),
    });
}
